import { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import { createRoles, getAllRoles, getRolesById, updateRoles } from "src/services/Roles/Merchants";

const { CCard, CCardHeader, CCardBody, CCol,  CRow, CButton, CForm, CFormLabel, CFormInput, CFormCheck, CCardFooter, CFormSelect } = require("@coreui/react");

const DEFAULT_SETTING = {
    name : '',
    booth_picker : false,
    dashboard : false,
    summary: false,
    transactions : false,
    transactions_detail : false,
    daily_recap : false,
    daily_recap_details : false,
    voucher_usage : false,
    voucher_usage_details : false,
    reviews : false,
    reviews_detail : false,
    branch_analytics : false,
    booths : false,
    booth_actions : false,
    merchant : false,
    merchant_actions : false,
    cash_and_bank : false,
    cash_and_bank_details : false,
    account_chart : false,
    account_chart_details : false,
    accounting_transactions : false,
    accounting_transactions_details : false,
    frames : false,
    frames_assignment : false,
    export_reports: false,
    role_setting: false,
} 

function Roles(){
    const [isEdit, setIsEdit] = useState(false)
    const [setting, setSetting] = useState(DEFAULT_SETTING)
    const [roles, setRoles] = useState([])
    const [validated, setValidated] = useState(false)
    const [selectedRole, setSelectedRole] = useState({})

    const formRef = useRef(null)

    const navigate = useNavigate()

    function handleChange(field, value){
        var clone = {...setting}
        clone[field] = value
        setSetting(clone)
    }

    function handleChangeRole(event){
        fetchRole(event.target.value)
    }

    async function fetchRole(id){
        await getRolesById(id).then(response => {
            setSelectedRole(response.data)
            var clone = {...setting}
            for (const [key, value] of Object.entries(response.data)){
                if (key != 'name'){
                    clone[key] = value == 1
                }
            }
            clone.name = response.data.name
            setSetting(clone)
        })
    }

    async function fetchRoles(){
        await getAllRoles().then(response => {
            setRoles(response.data.map(role => {
                return {...role, label: role.name, value: role.id}
            }))
        })
    }

    async function addNewRole(){
        if (formRef.current.checkValidity() === true){
            var clone = {...setting}
            for (const [key, value] of Object.entries(clone)){
                if (key != 'name'){
                    clone[key] = value ? 1 : 0
                }
            }
            await createRoles(clone).then(() => {
                navigate(0)
            })
        }
        setValidated(true)
    }

    async function updateRole(){
        if (formRef.current.checkValidity() === true){
            var clone = {...setting}
            for (const [key, value] of Object.entries(clone)){
                if (key != 'name'){
                    clone[key] = value ? 1 : 0
                }
            }
            clone.id = selectedRole.id
            await updateRoles(clone).then(() => {
                navigate(0)
            })
        }
        setValidated(true)
    }

    useEffect(() => {
        fetchRoles()
    },[])

    useEffect(() => {
        if (isEdit) {
            setSelectedRole(roles[0])
            var clone = {...setting}
            for (const [key, value] of Object.entries(roles[0])){
                if (key != 'name'){
                    clone[key] = value == 1
                }
            }
            clone.name = roles[0]?.name
            setSetting(clone)
        } else {
            setSelectedRole({})
            setSetting(DEFAULT_SETTING)
        }
    }, [isEdit])

    return (
        <CCard>
            <CCardHeader component={'h5'}>
                <CRow>
                    <CCol xs={9}>
                        Role Setting
                    </CCol>
                    <CCol xs={3}
                        style={{
                            display: 'flex',
                            justifyContent: "flex-end"
                        }}
                    >
                        <CButton
                            onClick={() => {
                                setIsEdit(!isEdit)
                            }}
                        >
                            {
                                isEdit ? 
                                'Add new role' :
                                'Edit existing role'
                            }
                        </CButton>
                    </CCol>
                </CRow>
            </CCardHeader>
            <CCardBody>
                <CForm className="needs-validation" noValidate validated={validated} ref={formRef}>
                    <CRow className="mb-3">
                        <CCol>
                            <CFormLabel>
                                Role Name
                            </CFormLabel>
                        </CCol>
                        <CCol xs={8}>
                            {
                                isEdit ?
                                <CFormSelect
                                    options={roles}
                                    onChange={(e) => {
                                        handleChangeRole(e)
                                    }}
                                /> : 
                                <CFormInput
                                    type="name"
                                    placeholder="admin"
                                    value={setting.name}
                                    onChange={(e) => {
                                        handleChange('name', e.target.value)
                                    }}
                                    feedbackInvalid={'Role name cannot be empty'}
                                    required
                                />
                            }
                        </CCol>
                    </CRow>
                    { isEdit &&
                        <CRow className="mb-3">
                            <CCol>
                                <CFormLabel>
                                    Edit Role Name
                                </CFormLabel>
                            </CCol>
                            <CCol xs={8}>
                                <CFormInput
                                    type="name"
                                    placeholder="admin"
                                    value={setting.name}
                                    onChange={(e) => {
                                        handleChange('name', e.target.value)
                                    }}
                                    feedbackInvalid={'Role name cannot be empty'}
                                    required
                                />
                            </CCol>
                        </CRow>
                    }
                    <CRow className="mb-3">
                        <CCol>
                            <CFormLabel>
                                Dashboard Permissions
                            </CFormLabel>
                        </CCol>
                        <CCol xs={8}>
                            <CFormCheck label={'View Dashboard'} checked={setting.dashboard} value={setting.dashboard} onChange={(e) => handleChange('dashboard', !setting.dashboard)}/>
                        </CCol>
                    </CRow>
                    <CRow className="mb-3">
                        <CCol>
                            <CFormLabel>
                                Report Permissions
                            </CFormLabel>
                        </CCol>
                        <CCol xs={8}>
                            <CFormCheck label={'View Summary'} checked={setting.summary} value={setting.summary} onChange={(e) => handleChange('summary', !setting.summary)}/>
                            <CFormCheck label={'View Daily Recap'} checked={setting.daily_recap} value={setting.daily_recap} onChange={(e) => handleChange('daily_recap', !setting.daily_recap)}/>
                            <CFormCheck label={'View Transaction List'} checked={setting.transactions} value={setting.transactions} onChange={(e) => handleChange('transactions', !setting.transactions)}/>
                            <CFormCheck label={'View Transaction List Detail'} checked={setting.transactions_detail} value={setting.transactions_detail} onChange={(e) => handleChange('transactions_detail', !setting.transactions_detail)}/>
                            <CFormCheck label={'View Voucher Usage'}  checked={setting.voucher_usage} value={setting.voucher_usage} onChange={(e) => handleChange('voucher_usage', !setting.voucher_usage)}/>
                            <CFormCheck label={'View Voucher Usage Detail'} checked={setting.voucher_usage_details} value={setting.voucher_usage_details} onChange={(e) => handleChange('voucher_usage_details', !setting.voucher_usage_details)}/>
                            <CFormCheck label={'View Reviews'}  checked={setting.reviews} value={setting.reviews} onChange={(e) => handleChange('reviews', !setting.reviews)}/>
                            <CFormCheck label={'View Reviews Detail'} checked={setting.reviews_detail} value={setting.reviews_detail} onChange={(e) => handleChange('reviews_detail', !setting.reviews_detail)}/>
                            <CFormCheck label={'View Branch Analytics'} checked={setting.branch_analytics} value={setting.branch_analytics} onChange={(e) => handleChange('branch_analytics', !setting.branch_analytics)}/>
                            <CFormCheck label={'Download Reports'} checked={setting.export_reports} value={setting.export_reports} onChange={(e) => handleChange('export_reports', !setting.export_reports)}/>
                        </CCol>
                    </CRow>
                    <CRow className="mb-3">
                        <CCol>
                            <CFormLabel>
                                Merchant Permissions
                            </CFormLabel>
                        </CCol>
                        <CCol xs={8}>
                            <CFormCheck label={'View Booths'} checked={setting.booths} value={setting.booths} onChange={(e) => handleChange('booths', !setting.booths)}/>
                            <CFormCheck label={'Add/Edit Booths'} checked={setting.booth_actions} value={setting.booth_actions} onChange={(e) => handleChange('booth_actions', !setting.booth_actions)}/>
                            <CFormCheck label={'View Merchants'} checked={setting.merchant} value={setting.merchant} onChange={(e) => handleChange('merchant', !setting.merchant)}/>
                            <CFormCheck label={'Add/Edit Merchants'} checked={setting.merchant_actions} value={setting.merchant_actions} onChange={(e) => handleChange('merchant_actions', !setting.merchant_actions)}/>
                        </CCol>
                    </CRow>
                    <CRow className="mb-3">
                        <CCol>
                            <CFormLabel>
                                Accounting Permissions
                            </CFormLabel>
                        </CCol>
                        <CCol xs={8}>
                            <CFormCheck label={'View Cash and Bank'} checked={setting.cash_and_bank} value={setting.cash_and_bank} onChange={(e) => handleChange('cash_and_bank', !setting.cash_and_bank)}/>
                            <CFormCheck label={'Add/Edit Cash and Bank'} checked={setting.cash_and_bank_details} value={setting.cash_and_bank_details} onChange={(e) => handleChange('cash_and_bank_details', !setting.cash_and_bank_details)}/>
                            <CFormCheck label={'View Chart of Accounts'} checked={setting.account_chart} value={setting.account_chart} onChange={(e) => handleChange('account_chart', !setting.account_chart)}/>
                            <CFormCheck label={'Add/Edit Chart of Accounts'} checked={setting.account_chart_details} value={setting.account_chart_details} onChange={(e) => handleChange('account_chart_details', !setting.account_chart_details)}/>
                            <CFormCheck label={'View Transactions'} checked={setting.accounting_transactions} value={setting.accounting_transactions} onChange={(e) => handleChange('accounting_transactions', !setting.accounting_transactions)}/>
                            <CFormCheck label={'Add/Edit Transactions'} checked={setting.accounting_transactions_details} value={setting.accounting_transactions_details} onChange={(e) => handleChange('accounting_transactions_details', !setting.accounting_transactions_details)}/>
                        </CCol>
                    </CRow>
                    <CRow className="mb-3">
                        <CCol>
                            <CFormLabel>
                                Utilities Permissions
                            </CFormLabel>
                        </CCol>
                        <CCol xs={8}>
                            <CFormCheck label={'View Frames'} checked={setting.frames} value={setting.frames} onChange={(e) => handleChange('frames', !setting.frames)}/>
                            <CFormCheck label={'Assign Frames'} checked={setting.frames_assignment} value={setting.frames_assignment} onChange={(e) => handleChange('frames_assignment', !setting.frames_assignment)}/>
                            <CFormCheck label={'View User Management'} checked={setting.role_setting} value={setting.role_setting} onChange={(e) => handleChange('role_setting', !setting.role_setting)}/>
                        </CCol>
                    </CRow>
                </CForm>
            </CCardBody>
            <CCardFooter className="text-end">
                {   isEdit ? 
                    <CButton
                        type="submit"
                        onClick={(e) => updateRole()}
                    >
                        Save
                    </CButton> :
                    <CButton
                        type="submit"
                        onClick={(e) => addNewRole()}
                    >
                        Submit
                    </CButton>
                }
            </CCardFooter>
        </CCard>
    )
} 

export default Roles